"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataHash = exports.NftOriginData = exports.requestStatusToJSON = exports.requestStatusFromJSON = exports.RequestStatus = exports.protobufPackage = void 0;
/* eslint-disable */
const opensea_1 = require("../nftoracle/opensea");
const minimal_1 = require("protobufjs/minimal");
exports.protobufPackage = "thesixnetwork.sixnft.nftoracle";
var RequestStatus;
(function (RequestStatus) {
    RequestStatus[RequestStatus["PENDING"] = 0] = "PENDING";
    RequestStatus[RequestStatus["SUCCESS_WITH_CONSENSUS"] = 1] = "SUCCESS_WITH_CONSENSUS";
    RequestStatus[RequestStatus["FAILED_WITHOUT_CONCENSUS"] = 2] = "FAILED_WITHOUT_CONCENSUS";
    RequestStatus[RequestStatus["EXPIRED"] = 3] = "EXPIRED";
    RequestStatus[RequestStatus["FAILED_ON_EXECUTION"] = 4] = "FAILED_ON_EXECUTION";
    RequestStatus[RequestStatus["FAILED_REJECT_BY_CONSENSUS"] = 5] = "FAILED_REJECT_BY_CONSENSUS";
    RequestStatus[RequestStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RequestStatus = exports.RequestStatus || (exports.RequestStatus = {}));
function requestStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "PENDING":
            return RequestStatus.PENDING;
        case 1:
        case "SUCCESS_WITH_CONSENSUS":
            return RequestStatus.SUCCESS_WITH_CONSENSUS;
        case 2:
        case "FAILED_WITHOUT_CONCENSUS":
            return RequestStatus.FAILED_WITHOUT_CONCENSUS;
        case 3:
        case "EXPIRED":
            return RequestStatus.EXPIRED;
        case 4:
        case "FAILED_ON_EXECUTION":
            return RequestStatus.FAILED_ON_EXECUTION;
        case 5:
        case "FAILED_REJECT_BY_CONSENSUS":
            return RequestStatus.FAILED_REJECT_BY_CONSENSUS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return RequestStatus.UNRECOGNIZED;
    }
}
exports.requestStatusFromJSON = requestStatusFromJSON;
function requestStatusToJSON(object) {
    switch (object) {
        case RequestStatus.PENDING:
            return "PENDING";
        case RequestStatus.SUCCESS_WITH_CONSENSUS:
            return "SUCCESS_WITH_CONSENSUS";
        case RequestStatus.FAILED_WITHOUT_CONCENSUS:
            return "FAILED_WITHOUT_CONCENSUS";
        case RequestStatus.EXPIRED:
            return "EXPIRED";
        case RequestStatus.FAILED_ON_EXECUTION:
            return "FAILED_ON_EXECUTION";
        case RequestStatus.FAILED_REJECT_BY_CONSENSUS:
            return "FAILED_REJECT_BY_CONSENSUS";
        default:
            return "UNKNOWN";
    }
}
exports.requestStatusToJSON = requestStatusToJSON;
const baseNftOriginData = { image: "", holder_address: "" };
exports.NftOriginData = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.image !== "") {
            writer.uint32(10).string(message.image);
        }
        if (message.holder_address !== "") {
            writer.uint32(18).string(message.holder_address);
        }
        for (const v of message.traits) {
            opensea_1.Trait.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseNftOriginData);
        message.traits = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.image = reader.string();
                    break;
                case 2:
                    message.holder_address = reader.string();
                    break;
                case 3:
                    message.traits.push(opensea_1.Trait.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseNftOriginData);
        message.traits = [];
        if (object.image !== undefined && object.image !== null) {
            message.image = String(object.image);
        }
        else {
            message.image = "";
        }
        if (object.holder_address !== undefined && object.holder_address !== null) {
            message.holder_address = String(object.holder_address);
        }
        else {
            message.holder_address = "";
        }
        if (object.traits !== undefined && object.traits !== null) {
            for (const e of object.traits) {
                message.traits.push(opensea_1.Trait.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.image !== undefined && (obj.image = message.image);
        message.holder_address !== undefined &&
            (obj.holder_address = message.holder_address);
        if (message.traits) {
            obj.traits = message.traits.map((e) => (e ? opensea_1.Trait.toJSON(e) : undefined));
        }
        else {
            obj.traits = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseNftOriginData);
        message.traits = [];
        if (object.image !== undefined && object.image !== null) {
            message.image = object.image;
        }
        else {
            message.image = "";
        }
        if (object.holder_address !== undefined && object.holder_address !== null) {
            message.holder_address = object.holder_address;
        }
        else {
            message.holder_address = "";
        }
        if (object.traits !== undefined && object.traits !== null) {
            for (const e of object.traits) {
                message.traits.push(opensea_1.Trait.fromPartial(e));
            }
        }
        return message;
    },
};
const baseDataHash = { confirmers: "" };
exports.DataHash = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.origin_data !== undefined) {
            exports.NftOriginData.encode(message.origin_data, writer.uint32(10).fork()).ldelim();
        }
        if (message.hash.length !== 0) {
            writer.uint32(18).bytes(message.hash);
        }
        for (const v of message.confirmers) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDataHash);
        message.confirmers = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.origin_data = exports.NftOriginData.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                case 3:
                    message.confirmers.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDataHash);
        message.confirmers = [];
        if (object.origin_data !== undefined && object.origin_data !== null) {
            message.origin_data = exports.NftOriginData.fromJSON(object.origin_data);
        }
        else {
            message.origin_data = undefined;
        }
        if (object.hash !== undefined && object.hash !== null) {
            message.hash = bytesFromBase64(object.hash);
        }
        if (object.confirmers !== undefined && object.confirmers !== null) {
            for (const e of object.confirmers) {
                message.confirmers.push(String(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.origin_data !== undefined &&
            (obj.origin_data = message.origin_data
                ? exports.NftOriginData.toJSON(message.origin_data)
                : undefined);
        message.hash !== undefined &&
            (obj.hash = base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        if (message.confirmers) {
            obj.confirmers = message.confirmers.map((e) => e);
        }
        else {
            obj.confirmers = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDataHash);
        message.confirmers = [];
        if (object.origin_data !== undefined && object.origin_data !== null) {
            message.origin_data = exports.NftOriginData.fromPartial(object.origin_data);
        }
        else {
            message.origin_data = undefined;
        }
        if (object.hash !== undefined && object.hash !== null) {
            message.hash = object.hash;
        }
        else {
            message.hash = new Uint8Array();
        }
        if (object.confirmers !== undefined && object.confirmers !== null) {
            for (const e of object.confirmers) {
                message.confirmers.push(e);
            }
        }
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
const atob = globalThis.atob ||
    ((b64) => globalThis.Buffer.from(b64, "base64").toString("binary"));
function bytesFromBase64(b64) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}
const btoa = globalThis.btoa ||
    ((bin) => globalThis.Buffer.from(bin, "binary").toString("base64"));
function base64FromBytes(arr) {
    const bin = [];
    for (let i = 0; i < arr.byteLength; ++i) {
        bin.push(String.fromCharCode(arr[i]));
    }
    return btoa(bin.join(""));
}
//# sourceMappingURL=request.js.map